<template>
  <div class="d-flex" :style="{ padding: '10px' }">
    <v-dialog v-model="dialog" hide-overlay persistent width="300">
      <v-card color="warning" dark>
        <v-card-text>
          Applying change
          <v-progress-linear indeterminate color="white" class="mb-0" />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-card
      class="d-flex pa-2 flex-column"
      :style="{ 'margin-bottom': '40px', width: '100%', height: 'unset' }"
    >
      <div
        :style="{ padding: '25px', paddingBottom: '10px', fontSize: 'small' }"
      >
        <v-row class="align-center">
          <v-col sm="2">Role Type</v-col>
          <v-col sm="1" style="text-align: center">:</v-col>
          <v-col sm="9">{{ roleType }}</v-col>
        </v-row>
        <v-row class="align-center">
          <v-col sm="2">Role Name</v-col>
          <v-col sm="1" style="text-align: center">:</v-col>
          <v-col sm="9">{{ role }}</v-col>
        </v-row>
      </div>
      <div
        class="d-flex pa-2 flex-wrap"
        :style="{ width: '100%', height: '500px' }"
      >
        <div
          class="d-flex pa-2 flex-column"
          :style="{ flex: '5', width: 'inherit' }"
        >
          <v-text-field
            :style="{ flex: '1' }"
            v-model="searchAvailable"
            label="Search for available"
          />
          <label for="selectedLeft"></label>
          <select
            v-model="selectedLeft"
            multiple
            class="d-flex pa-2 flex-column"
            :style="{ overflow: 'scroll', flex: '9' }"
            id="selectedLeft"
          >
            <optgroup label="Permission" v-if="itemsLeft.length != 0">
              <option v-for="(item, i) in itemsLeft" :key="i">
                {{ item.permission }}
              </option>
            </optgroup>
          </select>
        </div>
        <div
          class="d-flex pa-2 flex-column justify-center align-center"
          :style="{ flex: '1' }"
        >
          <v-btn
            color="warning"
            class="mb-2"
            @click="getPermission"
            :disabled="dialog || loading"
            ><v-icon>mdi-refresh</v-icon></v-btn
          >
          <v-btn
            color="red"
            style="color: white"
            class="mb-2"
            @click="toLeft"
            :disabled="dialog || loading"
            ><v-icon>mdi-chevron-double-left</v-icon></v-btn
          >
          <v-btn
            color="success"
            class="mb-2"
            @click="toRight"
            :disabled="dialog || loading"
            ><v-icon>mdi-chevron-double-right</v-icon></v-btn
          >
        </div>
        <div
          class="d-flex pa-2 flex-column"
          :style="{ flex: '5', width: 'inherit' }"
        >
          <v-text-field
            :style="{ flex: '1' }"
            v-model="searchAssigned"
            label="Search for assigned"
          />
          <label for="selectedRight"></label>
          <select
            v-model="selectedRight"
            multiple
            class="d-flex pa-2 flex-column"
            :style="{ overflow: 'scroll', flex: '9' }"
            id="selectedRight"
          >
            <optgroup label="Permission" v-if="itemsRight.length != 0">
              <option v-for="(item, i) in itemsRight" :key="i">
                {{ item.permission }}
              </option>
            </optgroup>
          </select>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import { date } from '../../lib/helpers';

export default {
  data: () => ({
    dialog: false,
    searchAvailable: '',
    searchAssigned: '',
    benched: 0,
    selectedLeft: [],
    selectedRight: [],
  }),
  mounted() {
    if (this.roleType == '') {
      this.$router.push('/rbac-role');
      return;
    }
    this.getPermission();
  },
  computed: {
    itemsLeft: {
      get() {
        const right = [];
        this.$store.state.rbac.permission.assignedPermissions.forEach(
          (data) => {
            right.push(data.permission);
          }
        );
        return this.$store.state.rbac.permission.allPermissions.filter(
          (x) =>
            !right.includes(x.permission) &&
            x.permission
              .toLowerCase()
              .search(this.searchAvailable.toLowerCase()) != -1
        );
      },
      set() {},
    },
    itemsRight: {
      get() {
        return this.$store.state.rbac.permission.assignedPermissions.filter(
          (x) =>
            x.permission
              .toLowerCase()
              .search(this.searchAssigned.toLowerCase()) != -1
        );
      },
      set() {},
    },
    loading() {
      return this.$store.state.rbac.permission.loading;
    },
    role() {
      const role = decodeURIComponent(this.$route.params.id);
      return role;
    },
    roleType() {
      const rtype = this.$store.state.rbac.role.detail;
      return rtype == null ? '' : rtype.role_type;
    },
  },
  methods: {
    getPermission() {
      this.$store.dispatch('rbac/permission/fetchPermissions', {
        date,
        role: this.role,
      });

      this.$store.dispatch('rbac/permission/fetchPermissions', {
        date,
        role: '',
      });
    },
    toRight() {
      if (this.selectedLeft.length > 0) {
        this.dialog = true;
        this.$store
          .dispatch('rbac/assignment/assign', {
            date,
            parent: this.role,
            child: this.selectedLeft,
          })
          .then((res) => {
            if (res) {
              this.getPermission();
            }
          })
          .finally(() => {
            this.dialog = false;
          });

        this.selectedLeft = [];
        this.selectedRight = [];
      }
    },
    toLeft() {
      if (this.selectedRight.length > 0) {
        this.dialog = true;
        this.$store
          .dispatch('rbac/assignment/revoke', {
            date,
            parent: this.role,
            child: this.selectedRight,
          })
          .then((res) => {
            if (res) {
              this.getPermission();
            }
          })
          .finally(() => {
            this.dialog = false;
          });

        this.selectedLeft = [];
        this.selectedRight = [];
      }
    },
  },
  beforeDestroy() {
    this.$store.commit('rbac/role/setDetailData', null);
  },
};
</script>
